import React, { useEffect, useState, useCallback } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Button, Container, FormControl, Grid, InputAdornment, ListItem, Paper, Tooltip, Typography, makeStyles, useTheme } from '@material-ui/core';
import DeleteSharpIcon from '@material-ui/icons/DeleteSharp'
import MigaPan from '../../app/orussystem/component/MigaPan';
import { PollPanelStyle } from '../infrastructure/PollPanelStyle';
import GetAppIcon from '@material-ui/icons/GetApp';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { ROL_USER } from '../../app/api-client/constants';
import { createDocumento } from '../../centraldevida/domain/api/DocumentosApi';
import { getlistDoc, deleteDocumento, loadFile } from '../../centraldevida/domain/api/DocumentosApi';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 320,
    },
    tableAction: {
        paddingLeft: 0,
        paddingRight: 0,
        margin: "0 auto",
        textAlign: "center",
        alignItems: "center"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '600px',
        margin: 'auto'

    },
    paperModal: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: '10px'
    },
    paperContent: {
        backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 1, 1),
        borderRadius: '10px'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },

    pos: {
        marginBottom: 12,
    },
    card: {
        padding: theme.spacing(3),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        height: '80px',
        marginTop: '-3%',
        marginBottom: '3.2%'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    title: {
        marginBottom: '30px',
        marginTop: '30px',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        marginLeft: '1%',
        fontWeight: 'bold', fontSize: '25px'
    },
    TableCell: {
        color: '#0088FE',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        fontSize: '17px',

    },
    paper1: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
}));


export default function Documento() {

    let { id } = useParams();
    const location = useLocation();
    const documentoId = location.state?.documentoId; //.toLowerCase();
    const clases = useStyles()

    let rol = localStorage.getItem(ROL_USER)
    const classes = PollPanelStyle();
    const [open, setOpen] = useState(false);
    const [, setshowLoad] = useState(false)
    const [, setFile] = useState();
    const [name, setName] = useState("");
    const [, setGuardar] = useState([]);
    const [url, setUrl] = useState();
    const [, setNameBascula] = useState("");
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setName("")
        setUrl("")
    };
    const dispatch = useDispatch();
    const [data, setData] = useState([]);

    const getDataTable = useCallback(async () => {
        const dataList = await getlistDoc(dispatch, id);
        try {
            setData(dataList.respuesta);
        } catch (err) {
            console.log("Ocurrio un error", err)
        }
    }, [dispatch, id]);


    useEffect(() => {
        const fetchData = async () => {
            await getDataTable();
        };
        fetchData();
    }, [getDataTable]);

    const create = async () => {
        try {
            await createDocumento(dispatch, {
                nombre: name,
                evbi: id,
                documento: url,
            });
            handleClose();
            setName("");
            setUrl("");
            getDataTable();
        } catch (err) {

            console.log("Ocurrio un error", err)
        }

    }
    const borrar = async (id) => {
        await deleteDocumento(dispatch, id);
        try {
            getDataTable();
        } catch (err) {
            console.log("Ocurrio un error", err)
        }

    }

    const onFileUploadFacture = async (event, type) => {
        type = type === null || type === undefined ? "" : type;
        setshowLoad(true);
        const file = event.target.files[0];
        if (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg" || file.type === "application/pdf" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            const formData = new FormData();
            setshowLoad(true);

            const lastDot = file.name === undefined ? file.name = "" : file.name.lastIndexOf(".");
            const ext = file.name.substring(lastDot + 1);
            const nombreBascula = documentoId.replace(/\s+/g, "_");

            const currentDate = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');

            // Combina la fecha y hora con el nombre proporcionado por el usuario
            const nombre = name.replace(/\s+/g, "_") + "_" + currentDate + "." + ext;

            setNameBascula(nombreBascula);
            setUrl(nombre);
            formData.append("file", file, nombre);
            if (file.size < 10485760 && id !== "") {
                const File = await loadFile(dispatch, nombreBascula, formData);
                try {
                    setFile(File.codigoRespuesta);
                } catch (err) {
                    console.log("Ocurrio un error", err);
                }
            }
        }
    };

    const changeFormatDate = (date) => {
        let fecha = new Date(date);
        let año = fecha.getFullYear();
        let mes = fecha.getMonth() + 1;
        let day = fecha.getDate();
        mes = mes < 10 ? `0${mes}` : mes;
        day = day < 10 ? `0${day}` : day;
        fecha = `${año}-${mes}-${day}`
        return fecha
    }

    const handleOnClick = (file) => {
        window.open('https://s3.amazonaws.com/' + process.env.REACT_APP_AWS_BUCKET + `/DOCUMENTOS_BASCULAS/${documentoId.replace(/\s+/g, "_")}/${file}`)
    };
    const inputStyles = {
        border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
        color: 'black',
    };
    const urlStyles = {
        border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
        color: 'black',
        marginLeft: '8%'
    };
    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage={`Documentos`}
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas"
                >
                    Home
                </MigaPan>
            </Grid>

            <Paper className={clases.paper1} >
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} className={classes.searchContainer} >
                            <Typography style={{ fontSize: '25px', fontWeight: 'bold', marginTop: '2.5%', marginBottom: '2%', width: '50%', marginRight: '40%' }} color='primary'>Documentos </Typography>
                            {rol !== 'ROLE_USER'&&(
                            <Button
                                variant="contained"
                                color="primary"
                                type="button" onClick={handleOpen}
                                style={{ borderRadius: '10px', alignContent: 'right' }}
                            >
                                Cargar
                            </Button>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <Table>
                                <TableHead color='primary'>
                                    <TableRow color='primary'>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', color: primaryColor }}>Nombre</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', color: primaryColor }}>Fecha</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '7%', color: primaryColor }}>Descargar</TableCell>
                                        {rol !== 'ROLE_USER' ? (
                                            <TableCell className={clases.TableCell} style={{ paddingLeft: '1%', color: primaryColor }}>
                                                Eliminar
                                            </TableCell>
                                        ) : (
                                            <TableCell className={clases.TableCell} style={{ paddingLeft: '1%', color: primaryColor,width:'25%'}}/>
                                        )}
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </Grid>

                        <Grid item xs={12}>
                            <Table size="small">
                                <TableBody>
                                    {data.map((row) => (
                                        <Paper key={row.id} className={clases.card}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={3} style={{ width: '14%', fontWeight: 'bold', fontSize: '16px' }}>
                                                    {row.nombre}
                                                </Grid>
                                                <Grid item xs={2} style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                                    {changeFormatDate(row.updated)}
                                                </Grid>
                                                <Grid item xs={3} style={{ width: '20%' }} className={classes.actionsStyles} onClick={() => { handleOnClick(row.archivo) }}>
                                                    <ListItem button >
                                                        <Tooltip title="Descargar" aria-label="top-end">
                                                            <GetAppIcon className={classes.tableAction} style={{ color: primaryColor }} />
                                                        </Tooltip>
                                                    </ListItem>
                                                </Grid>
                                                {rol !== 'ROLE_USER' && (
                                                    <Grid item xs={3} style={{ width: '10%' }} className={classes.actionsStyles}>
                                                        <ListItem button >
                                                            <Tooltip title="Eliminar" aria-label="top-end">
                                                                <DeleteSharpIcon onClick={() => { borrar(row.id) }} className={classes.tableAction} style={{ color: primaryColor }} />
                                                            </Tooltip>
                                                        </ListItem>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Paper>
                                    ))}
                                    {(!data || data.length === 0) && (
                                        <Paper className={clases.card}>
                                            <Typography variant="h6">No hay Documentos disponibles</Typography>
                                        </Paper>
                                    )}
                                </TableBody>
                            </Table>
                        </Grid>
                        <div>
                            <Modal
                                className={classes.modal}
                                open={open}
                                onClose={handleClose}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 500,
                                }}
                            >
                                <Fade in={open}>
                                    <div className={classes.paperModal}>
                                        <Container>
                                            <Grid item xs={12} md={12} sm={12} style={{ marginTop: '2rem' }} >
                                                <FormControl fullWidth variant="outlined">

                                                    <input
                                                        placeholder='Nombre'
                                                        id="nombre"
                                                        type="text"
                                                        name='nombre'
                                                        style={inputStyles}
                                                        startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                                        label="Nombre"
                                                        value={name}
                                                        autoComplete='off'
                                                        onChange={e => {
                                                            setName(e.target.value);
                                                        }}
                                                    />
                                                </FormControl>
                                                {/*touched.nombre && errors.nombre && <div style={{ color: "red" }}>{errors.nombre}</div>*/}
                                            </Grid>
                                            <Grid item xs={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2rem' }}>
                                                <FormControl fullWidth variant="outlined">

                                                    <input
                                                        placeholder='URL Documento'
                                                        id="documento"
                                                        type="text"
                                                        name='documento'
                                                        disabled
                                                        value={url}
                                                        startAdornment={<InputAdornment position="start"></InputAdornment>}
                                                        label="documento"
                                                        style={urlStyles}
                                                    />
                                                </FormControl>
                                                <div className={classes.root}>
                                                    <input
                                                        accept="image/jpeg, image/png, image/jpg, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                        className={classes.input}
                                                        id="contained-button-file"
                                                        multiple
                                                        type="file"
                                                        onChange={((e) => { onFileUploadFacture(e,) })}

                                                    />
                                                    <label htmlFor="contained-button-file">
                                                        <Button variant="contained" color="primary" component="span" disabled={!name} style={{ borderRadius: '10px' }}>
                                                            Cargar
                                                        </Button>
                                                    </label>
                                                    <input accept="image/*" className={classes.input} id="icon-button-file" type="file" />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} style={{ textAlign: "center", marginTop: '2rem' }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    type="button"
                                                    onClick={create}
                                                    disabled={!name || !url}
                                                    style={{ marginRight: '2%', borderRadius: '10px' }}


                                                >
                                                    Guardar
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    type="button"
                                                    onClick={handleClose}
                                                    style={{ borderRadius: '10px' }}

                                                >
                                                    Cancelar
                                                </Button>
                                            </Grid>

                                        </Container>
                                    </div>
                                </Fade>
                            </Modal>


                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );


}